import React from 'react';
import classNames from 'classnames';
import css from './PendingReviewOpportunitiesCarousel.module.css';

const coachInitials = name => {
  const parts = String(name || 'C')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return (parts[0]?.[0] || 'C').toUpperCase();
};

export const formatReviewSessionDate = isoDate => {
  if (!isoDate) return null;
  try {
    return new Date(isoDate).toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return null;
  }
};

const PendingReviewOpportunitiesCarousel = ({
  opportunities,
  selectedTransactionId,
  onSelect,
}) => {
  if (!opportunities?.length) {
    return null;
  }

  return (
    <div className={css.wrapper}>
      <div className={css.track} role="list" aria-label="Sessions awaiting your review">
        {opportunities.map(opp => {
          const isSelected = opp.transactionId === selectedTransactionId;
          const sessionDateLabel = formatReviewSessionDate(opp.sessionDate);
          const participantName =
            opp.reviewTarget === 'customer'
              ? opp.customerDisplayName || 'Customer'
              : opp.coachDisplayName || 'Coach';
          const participantImage =
            opp.reviewTarget === 'customer' ? opp.customerProfileImage : opp.coachProfileImage;

          return (
            <button
              key={opp.transactionId}
              type="button"
              role="listitem"
              className={classNames(css.card, isSelected && css.cardSelected)}
              aria-pressed={isSelected}
              onClick={() => onSelect(opp.transactionId)}
            >
              {participantImage ? (
                <img
                  className={css.avatar}
                  src={participantImage}
                  alt=""
                />
              ) : (
                <span className={css.avatarPlaceholder} aria-hidden>
                  {coachInitials(participantName)}
                </span>
              )}
              <p className={css.coachName}>{participantName}</p>
              {opp.bookingCode ? (
                <p className={css.bookingCode}>{opp.bookingCode}</p>
              ) : null}
              {opp.sessionTitle ? (
                <p className={css.sessionTitle}>{opp.sessionTitle}</p>
              ) : null}
              {sessionDateLabel ? (
                <p className={css.sessionDate}>{sessionDateLabel}</p>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PendingReviewOpportunitiesCarousel;
